export default {
      id: "tabStripNewItem-usage",
      viewBox: "0 0 10 10",
      url: __webpack_public_path__ + "assets/webdesktop/web-desktop-sprite.svg#tabStripNewItem",
      toString: function () {
        return this.url;
      }
    }